/**
 * PRX-80 — the frontend half of the Fillware prescription-status word set.
 * Carries the same six values as the backend catalogue
 * (`backend-v2/src/common/fillware/rx-status-words.ts`) plus the
 * sentence-case display label for each value.
 *
 * The array below is declared literally, not derived from the labels
 * object's key order, so the drift spec (`rxStatusWords.drift.spec.ts`) has
 * something independent to compare against the backend file. If you add,
 * remove or rename a value, update both files.
 *
 * A Kroll row carries `rxStatusWord: null` — the UI falls back to the
 * existing two chips in that case rather than looking up a label here.
 */

export const RX_STATUS_WORDS = [
  'active', 'hold', 'transferred_in', 'transferred_out', 'inactive', 'deleted',
] as const;
export type RxStatusWord = (typeof RX_STATUS_WORDS)[number];

export const RX_STATUS_WORD_LABELS: Record<RxStatusWord, string> = {
  active: 'Active',
  hold: 'Hold',
  transferred_in: 'Transferred in',
  transferred_out: 'Transferred out',
  inactive: 'Inactive',
  deleted: 'Deleted',
};

/**
 * Chip colour per word, shared by the Patient 360 Rx Active cell and the
 * medication pickers' Rx Active chip (PRX-165 B1) so the two never disagree.
 * Colour is never the only signal — the label is always the chip's text.
 */
export const RX_STATUS_WORD_COLORS: Record<RxStatusWord, 'success' | 'warning' | 'info' | 'default' | 'error'> = {
  active: 'success',
  hold: 'warning',
  transferred_in: 'info',
  transferred_out: 'info',
  inactive: 'default',
  deleted: 'error',
};
